import $axios from "@/api";

const state = () => ({
    data: {
        listOptimize: []
    },
})

const mutations = {
    ASSIGN_DATA(state,payload){
        state.data[payload.target] = payload.data
    },
    ASSIGN_FILTER(state, payload){
        state.filter[payload.target] = payload.data
    }
}

const actions = {
    getListDriver( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`driver/list_by_depo/${payload}`).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    getListAllDriver({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`driver`).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    async getDriverOptimize({commit}, payload){
        try{
            const response =  await $axios.get('driver/list_optimizer?per_page='+payload.paginate.per_page+'&page='+payload.paginate.current_page+'&keyword='+payload.keyword)
            commit('ASSIGN_DATA',{data:response.data.data,target:'listOptimize'})
            return response.data.meta
        }catch(error){
            console.log(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
